import { createBrowserHistory } from "history";

const history = createBrowserHistory<{} | null | undefined>();

export default history;
